import { useEffect, useState } from "react";
import axios from "axios";
import { Badge } from "@/components/ui/badge";
import { AudioLines, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminAnalysisReviewPanel = ({ profile, hasVideo, song, songId }) => {
  const { getAuthHeaders } = useAuth();
  const [matches, setMatches] = useState([]);
  useEffect(() => {
    if (!song?.title?.trim()) return;
    axios.get(`${API_URL}/global-songs/match-candidates`, {
      headers: getAuthHeaders(),
      params: { title: song.title, artist: song.artist || undefined, bpm: song.bpm || undefined, key: song.key || undefined },
    }).then(({ data }) => {
      setMatches((data || []).filter((item) => item.global_song?.id !== songId).slice(0, 3));
    }).catch(() => setMatches([]));
  }, [getAuthHeaders, song?.artist, song?.bpm, song?.key, song?.title, songId]);
  const checks = [
    { label: "Video elegido", ready: hasVideo },
    { label: "Timeline de acordes", ready: Boolean(profile.chords?.length) },
    { label: "Tonalidad y BPM", ready: Boolean(profile.key && profile.bpm) },
    { label: "Sincronizacion revisada", ready: Boolean(profile.chords?.length && hasVideo) },
  ];
  return (
    <section className="rounded-2xl border border-white/10 bg-white/[0.045] p-4 sm:p-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 text-lg font-semibold text-white"><AudioLines className="h-5 w-5 text-cyan-200" /> Revision del analisis musical</h2>
          <p className="text-sm text-slate-400">El catalogo recibe BPM, key, acordes y secciones desde analisis MP3 autorizado o curacion admin.</p>
        </div>
        <Badge className="bg-cyan-300/10 text-cyan-100">{Math.round(Number(profile.confidence || 0) * 100)}% confidence</Badge>
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {checks.map((item) => (
          <p key={item.label} className={`flex items-center gap-2 rounded-xl border p-3 text-sm ${item.ready ? "border-emerald-300/20 text-emerald-100" : "border-white/10 text-slate-400"}`}>
            <CheckCircle2 className="h-4 w-4" /> {item.label}
          </p>
        ))}
      </div>
      {matches.length > 0 && (
        <div className="mt-4 rounded-xl border border-amber-300/20 bg-amber-300/[0.05] p-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-amber-100">Posibles coincidencias</p>
          {matches.map((match) => (
            <p key={match.global_song.id} className="mt-2 text-sm text-slate-300">
              {match.global_song.canonical_title} - {match.global_song.canonical_artist || "Sin artista"} ({Math.round(match.confidence * 100)}%)
            </p>
          ))}
          <p className="mt-2 text-xs text-slate-400">Confirma si es otra version antes de publicar.</p>
        </div>
      )}
    </section>
  );
};

export default AdminAnalysisReviewPanel;
